export default {"src":"/_next/static/media/qr.f75a6b89.svg","height":1125,"width":1125,"blurWidth":0,"blurHeight":0};